import React, { memo } from "react";
import useStyles from "./styles";
import DialogBottom from "components/DialogBottom";
import clsx from "clsx";

import { Images } from "config/images";
import { Grid } from "@material-ui/core";
import { formatDate } from "config/constant";
import { isEmpty } from "lodash";

const DialogLoyalty = memo(props => {
	const classes = useStyles();
	const { open, handleClose, loyaltyDetail } = props;

	return (
		<DialogBottom open={open} handleClose={handleClose}>
			<Grid classes={{ root: classes.title }}>{loyaltyDetail?.name}</Grid>
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.condition }}>
					<Grid classes={{ root: classes.subTitle }}>Điều kiện</Grid>
					<div
						style={{
							marginBottom: "10px",
							whiteSpace: "pre-wrap"
						}}
						dangerouslySetInnerHTML={{
							__html: loyaltyDetail?.description
						}}
					/>
				</Grid>
				{loyaltyDetail.giftQuantity &&
					!isEmpty(loyaltyDetail.giftQuantity) && (
						<React.Fragment>
							<Grid classes={{ root: classes.rootProgram }}>
								<Grid classes={{ root: classes.iconProgram }}>
									<img
										src={Images.icBgPrice}
										alt={"icBgPrice"}
									/>
								</Grid>
								<Grid classes={{ root: classes.titleProgram }}>
									Chương trình tích luỹ:{" "}
									<span>Tặng sản phẩm</span>
								</Grid>
							</Grid>
							{loyaltyDetail?.giftQuantity?.conditionRewards.map(
								(quantity, index) => (
									<Grid
										classes={{ root: classes.condition }}
										key={index}
									>
										<div
											style={{
												marginBottom: "10px",
												whiteSpace: "pre-wrap"
											}}
											dangerouslySetInnerHTML={{
												__html: quantity.des
											}}
										/>
									</Grid>
								)
							)}
						</React.Fragment>
					)}
				{loyaltyDetail.giftAmount &&
					!isEmpty(loyaltyDetail.giftAmount) && (
						<React.Fragment>
							<Grid classes={{ root: classes.rootProgram }}>
								<Grid classes={{ root: classes.iconProgram }}>
									<img
										src={Images.icBgPrice}
										alt={"icBgPrice"}
									/>
								</Grid>
								<Grid classes={{ root: classes.titleProgram }}>
									Chương trình tích luỹ:{" "}
									<span>Tặng tiền mua hàng</span>
								</Grid>
							</Grid>
							{loyaltyDetail?.giftAmount?.conditionRewards.map(
								(quantity, index) => (
									<Grid
										classes={{ root: classes.condition }}
										key={index}
									>
										<div
											style={{
												marginBottom: "10px",
												whiteSpace: "pre-wrap"
											}}
											dangerouslySetInnerHTML={{
												__html: quantity.des
											}}
										/>
									</Grid>
								)
							)}
						</React.Fragment>
					)}
				{loyaltyDetail.giftDiscount &&
					!isEmpty(loyaltyDetail.giftDiscount) && (
						<React.Fragment>
							<Grid classes={{ root: classes.rootProgram }}>
								<Grid classes={{ root: classes.iconProgram }}>
									<img
										src={Images.icBgPrice}
										alt={"icBgPrice"}
									/>
								</Grid>
								<Grid classes={{ root: classes.titleProgram }}>
									Chương trình tích luỹ:{" "}
									<span>Tặng % chiết khấu</span>
								</Grid>
							</Grid>
							{loyaltyDetail?.giftDiscount?.conditionRewards.map(
								(quantity, index) => (
									<Grid
										classes={{ root: classes.condition }}
										key={index}
									>
										<div
											style={{
												marginBottom: "10px",
												whiteSpace: "pre-wrap"
											}}
											dangerouslySetInnerHTML={{
												__html: quantity.des
											}}
										/>
									</Grid>
								)
							)}
						</React.Fragment>
					)}
				<Grid classes={{ root: clsx(classes.condition, classes.mb30) }}>
					<Grid classes={{ root: classes.textTime }}>
						Thời gian đăng ký:{" "}
						{formatDate(loyaltyDetail?.startTimeRegister)} -{" "}
						{formatDate(loyaltyDetail?.endTimeRegister)}
					</Grid>
					<Grid classes={{ root: classes.textTime }}>
						Thời gian áp dụng :{" "}
						{formatDate(loyaltyDetail?.startTimeApply)} -{" "}
						{formatDate(loyaltyDetail?.endTimeApply)}
					</Grid>
					<Grid classes={{ root: classes.textTime }}>
						Thời gian trả thưởng:{" "}
						{formatDate(loyaltyDetail?.startTimeReward)} -{" "}
						{formatDate(loyaltyDetail?.endTimeReward)}
					</Grid>
				</Grid>
			</Grid>
		</DialogBottom>
	);
});

export default DialogLoyalty;
